// Mock data for Admin Panel

export const mockAdminUser = {
  id: 'admin1',
  email: 'admin@netixfibernet.com',
  name: 'Admin User',
  role: 'admin',
  isAuthenticated: false
};

export const mockAllUsers = [
  {
    id: '1',
    firstName: 'Rajesh',
    lastName: 'Kumar',
    email: 'rajesh.kumar@example.com',
    referralCode: 'RAJESH2024',
    balance: 4500,
    pendingBalance: 2300,
    lifetimeEarnings: 15800,
    totalClicks: 234,
    totalConversions: 18,
    currentTier: 2,
    salesThisMonth: 8,
    status: 'active',
    joinedDate: '2024-11-15',
    payoutMethod: 'Bank Transfer'
  },
  {
    id: '2',
    firstName: 'Priya',
    lastName: 'Sharma',
    email: 'priya.sharma@example.com',
    referralCode: 'PRIYA8956',
    balance: 8200,
    pendingBalance: 3400,
    lifetimeEarnings: 28600,
    totalClicks: 456,
    totalConversions: 32,
    currentTier: 3,
    salesThisMonth: 18,
    status: 'active',
    joinedDate: '2024-10-20',
    payoutMethod: 'UPI'
  },
  {
    id: '3',
    firstName: 'Amit',
    lastName: 'Patel',
    email: 'amit.patel@example.com',
    referralCode: 'AMIT3421',
    balance: 1200,
    pendingBalance: 800,
    lifetimeEarnings: 5600,
    totalClicks: 98,
    totalConversions: 7,
    currentTier: 1,
    salesThisMonth: 3,
    status: 'active',
    joinedDate: '2025-01-05',
    payoutMethod: 'PayPal'
  },
  {
    id: '4',
    firstName: 'Neha',
    lastName: 'Singh',
    email: 'neha.singh@example.com',
    referralCode: 'NEHA7834',
    balance: 0,
    pendingBalance: 1500,
    lifetimeEarnings: 12300,
    totalClicks: 187,
    totalConversions: 14,
    currentTier: 2,
    salesThisMonth: 6,
    status: 'blocked',
    joinedDate: '2024-12-01',
    payoutMethod: 'Bank Transfer'
  },
  {
    id: '5',
    firstName: 'Vikram',
    lastName: 'Mehta',
    email: 'vikram.mehta@example.com',
    referralCode: 'VIKRAM9012',
    balance: 6700,
    pendingBalance: 2100,
    lifetimeEarnings: 19800,
    totalClicks: 312,
    totalConversions: 24,
    currentTier: 2,
    salesThisMonth: 11,
    status: 'active',
    joinedDate: '2024-11-10',
    payoutMethod: 'UPI'
  }
];

export const mockAllTransactions = [
  {
    id: 'txn001',
    userId: '1',
    userName: 'Rajesh Kumar',
    date: '2025-01-15',
    type: 'Sale',
    orderId: 'ORD-2025-001',
    customerName: 'Amit',
    amount: 1200,
    commission: 96,
    commissionRate: 8,
    status: 'Confirmed',
    product: 'Internet Lease Line - 100 Mbps'
  },
  {
    id: 'txn002',
    userId: '2',
    userName: 'Priya Sharma',
    date: '2025-01-14',
    type: 'Sale',
    orderId: 'ORD-2025-005',
    customerName: 'Ravi',
    amount: 2500,
    commission: 300,
    commissionRate: 12,
    status: 'Pending',
    product: 'CCTV Camera Package'
  },
  {
    id: 'txn003',
    userId: '1',
    userName: 'Rajesh Kumar',
    date: '2025-01-12',
    type: 'Sale',
    orderId: 'ORD-2025-002',
    customerName: 'Priya',
    amount: 2500,
    commission: 200,
    commissionRate: 8,
    status: 'Pending',
    product: 'CCTV Camera Package'
  },
  {
    id: 'txn004',
    userId: '3',
    userName: 'Amit Patel',
    date: '2025-01-12',
    type: 'Sale',
    orderId: 'ORD-2025-006',
    customerName: 'Sunita',
    amount: 1800,
    commission: 90,
    commissionRate: 5,
    status: 'Pending',
    product: 'Internet Networking Setup'
  },
  {
    id: 'txn005',
    userId: '2',
    userName: 'Priya Sharma',
    date: '2025-01-10',
    type: 'Payout',
    orderId: '-',
    customerName: '-',
    amount: 5000,
    commission: -5000,
    commissionRate: 0,
    status: 'Paid',
    product: 'Withdrawal to UPI'
  },
  {
    id: 'txn006',
    userId: '5',
    userName: 'Vikram Mehta',
    date: '2025-01-08',
    type: 'Sale',
    orderId: 'ORD-2025-003',
    customerName: 'Sandeep',
    amount: 1800,
    commission: 144,
    commissionRate: 8,
    status: 'Confirmed',
    product: 'Internet Networking Setup'
  },
  {
    id: 'txn007',
    userId: '2',
    userName: 'Priya Sharma',
    date: '2025-01-05',
    type: 'Sale',
    orderId: 'ORD-2025-004',
    customerName: 'Neha',
    amount: 3500,
    commission: 420,
    commissionRate: 12,
    status: 'Pending',
    product: 'Internet Lease Line - 200 Mbps'
  },
  {
    id: 'txn008',
    userId: '4',
    userName: 'Neha Singh',
    date: '2024-12-28',
    type: 'Adjustment',
    orderId: 'ORD-2024-098',
    customerName: 'Vikram',
    amount: 1500,
    commission: -120,
    commissionRate: 8,
    status: 'Rejected',
    product: 'CCTV Camera - Refunded'
  }
];

export const mockAllOrders = [
  {
    id: 'ORD-1738353001234',
    referrerId: '1',
    referrerName: 'Rajesh Kumar',
    customerName: 'Amit Kumar',
    customerEmail: 'amit@example.com',
    mobileNumber: '+91 9876543210',
    address: 'Street 123, Delhi, India - 110001',
    latitude: '28.6139',
    longitude: '77.2090',
    productType: 'Internet Leaseline',
    speedRequired: '100 Mbps',
    status: 'Pending',
    statusHistory: [
      { status: 'Pending', date: '2025-01-15T10:30:00Z', note: 'Order placed' }
    ],
    createdAt: '2025-01-15T10:30:00Z',
    updatedAt: '2025-01-15T10:30:00Z'
  },
  {
    id: 'ORD-1738266601234',
    referrerId: '2',
    referrerName: 'Priya Sharma',
    customerName: 'Ravi Gupta',
    customerEmail: 'ravi@example.com',
    mobileNumber: '+91 9123456789',
    address: '456 MG Road, Bangalore, Karnataka - 560001',
    latitude: '12.9716',
    longitude: '77.5946',
    productType: 'CCTV Security Camera',
    speedRequired: '',
    status: 'In Progress',
    statusHistory: [
      { status: 'Pending', date: '2025-01-14T09:00:00Z', note: 'Order placed' },
      { status: 'Accepted', date: '2025-01-14T11:00:00Z', note: 'Order accepted by admin' },
      { status: 'In Progress', date: '2025-01-14T14:00:00Z', note: 'Installation team assigned' }
    ],
    createdAt: '2025-01-14T09:00:00Z',
    updatedAt: '2025-01-14T14:00:00Z'
  },
  {
    id: 'ORD-1738180201234',
    referrerId: '3',
    referrerName: 'Amit Patel',
    customerName: 'Sunita Verma',
    customerEmail: 'sunita@example.com',
    mobileNumber: '+91 9988776655',
    address: '789 Park Street, Mumbai, Maharashtra - 400001',
    latitude: '19.0760',
    longitude: '72.8777',
    productType: 'Enterprise Broadband',
    speedRequired: '200 Mbps',
    status: 'Accepted',
    statusHistory: [
      { status: 'Pending', date: '2025-01-13T15:00:00Z', note: 'Order placed' },
      { status: 'Accepted', date: '2025-01-13T16:30:00Z', note: 'Order verified and accepted' }
    ],
    createdAt: '2025-01-13T15:00:00Z',
    updatedAt: '2025-01-13T16:30:00Z'
  },
  {
    id: 'ORD-1738007401234',
    referrerId: '1',
    referrerName: 'Rajesh Kumar',
    customerName: 'Meena Sharma',
    customerEmail: 'meena@example.com',
    mobileNumber: '+91 9845612378',
    address: '321 Nehru Place, New Delhi - 110019',
    latitude: '28.5494',
    longitude: '77.2501',
    productType: 'Internet Networking',
    speedRequired: '',
    status: 'Completed',
    statusHistory: [
      { status: 'Pending', date: '2025-01-11T08:00:00Z', note: 'Order placed' },
      { status: 'Accepted', date: '2025-01-11T10:00:00Z', note: 'Order accepted' },
      { status: 'In Progress', date: '2025-01-11T12:00:00Z', note: 'Setup started' },
      { status: 'Completed', date: '2025-01-11T18:00:00Z', note: 'Installation completed successfully' }
    ],
    createdAt: '2025-01-11T08:00:00Z',
    updatedAt: '2025-01-11T18:00:00Z'
  },
  {
    id: 'ORD-1737834601234',
    referrerId: '5',
    referrerName: 'Vikram Mehta',
    customerName: 'Deepak Singh',
    customerEmail: 'deepak@example.com',
    mobileNumber: '+91 9765432100',
    address: '555 Sector 18, Noida, UP - 201301',
    latitude: '28.5706',
    longitude: '77.3272',
    productType: 'Internet Leaseline',
    speedRequired: '500 Mbps',
    status: 'Rejected',
    statusHistory: [
      { status: 'Pending', date: '2025-01-09T14:00:00Z', note: 'Order placed' },
      { status: 'Rejected', date: '2025-01-09T16:00:00Z', note: 'Service not available in this area' }
    ],
    createdAt: '2025-01-09T14:00:00Z',
    updatedAt: '2025-01-09T16:00:00Z'
  }
];

export const mockAdminStats = {
  totalUsers: 5,
  activeUsers: 4,
  blockedUsers: 1,
  totalCommissionsPaid: 68200,
  pendingCommissions: 10200,
  totalSales: 156,
  thisMonthSales: 46,
  totalRevenue: 234500,
  pendingApprovals: 4,
  totalOrders: 5,
  pendingOrders: 1,
  acceptedOrders: 1,
  inProgressOrders: 1,
  completedOrders: 1,
  rejectedOrders: 1
};
